module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAQCAYAAADwMZRfAAAA/UlEQVQ4T7WTu0oDURRF1x4QGxUULC0FLbSJPyDYiOlEYh/QD7CxnEaw8A8UbYIESSOOafIDdmLjRygomEZEZ8sEEoKZwbk+bnvPXmed+9BxM9mROMJMEr5ewHs6aSZPwHR4fpB4ziD+BaAX/SeI1JHpfLUzrILX86zzTO5ANyPF8gqmUhYSfESjJtK1ICki2ekaaHN4P2cc3RvfFkEiWDYsfQMJnubvrvgBmA3vP0g86vSiXXPqQ+TCv2MzAYwPNXqT6GJ1FWlfZQzOWlfzH++6BBZ7z1y06rXqVj9bCpIVNxrtqdex9Byz8WNIBorjOJpbqByAZurb1d2+ySeitlw4TfziVAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/center/menu/msg.png
// module id = zrHW
// module chunks = 26